import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import endpoints from 'constants/endpoints';
import { UPDATE_CALENDAR_EVENTS } from 'constants/types';
import { safePostCall } from 'helpers/firebaseSetup';
import { parseZohoJsonOutput } from 'helpers/zoho/response-parsers';

export default function useNewEvent() {
  const dispatch = useDispatch();
  const zohoId = useSelector(state => state.user?.zohoData.id);
  const calendarEvents = useSelector(
    state => state.dashboard?.calendarEvents ?? []
  );
  const [active, setActive] = useState(false);

  const submitEvent = async ({
    action,
    eventId,
    title,
    description,
    startTime,
    endTime
  }) => {
    const body = {
      zohoId,
      endpoint: endpoints.zoho.editAgentCalendarEvents,
      isZohoRequest: true,
      action,
      agentId: String(zohoId ?? ''),
      title: title ?? '',
      description:
        description === undefined || description === null
          ? null
          : String(description),
      startTime: startTime ?? '',
      endTime: endTime ?? ''
    };
    if (action === 'edit' || action === 'delete') {
      body.eventId = String(eventId ?? '');
    }

    const res = await safePostCall(endpoints.awsProxy.safePost, body);
    if (!res?.data?.details?.output) {
      return { ok: false, message: 'No response from server' };
    }
    const { ok, message, data } = parseZohoJsonOutput(res.data.details.output);
    if (!data) {
      return { ok: false, message, eventId: null };
    }
    const newEventId = data.eventId;

    if (ok) {
      let newArray;
      if (action === 'add') {
        newArray = [
          ...calendarEvents,
          {
            id: newEventId,
            title: title ?? '',
            description: description ?? null,
            startTime: startTime ?? '',
            endTime: endTime ?? ''
          }
        ];
      } else if (action === 'edit') {
        newArray = calendarEvents.map(ev =>
          ev.id === String(eventId)
            ? {
                ...ev,
                title: title ?? ev.title,
                description: description ?? null,
                startTime: startTime ?? ev.startTime,
                endTime: endTime ?? ''
              }
            : ev
        );
      } else if (action === 'delete') {
        newArray = calendarEvents.filter(ev => ev.id !== String(eventId));
      } else {
        newArray = calendarEvents;
      }
      dispatch({ type: UPDATE_CALENDAR_EVENTS, payload: newArray });
    }

    return { ok, message };
  };

  return { active, setActive, submitEvent };
}
